import React from 'react';

const IsAdminViewContext = React.createContext(false);

export default IsAdminViewContext;
